import { ref, watch, computed } from "vue";

import useBonusomatData from "./use-bonusomat-data";
import { useNgSession } from "@sazka/ng/ng-session";

const { isLoggedIn, session } = useNgSession();

const { defaultDrawData, loadDefaultDrawData, loadTotalTickets } = useBonusomatData();

const playerId = computed(() => session.value?.PlayerID);

let intervalTotalTicketsHandle = 0;
async function intervalTotalTicketsHandler() {
    if (playerId.value) {
        await loadTotalTickets();
    } else if (intervalTotalTicketsHandle) {
        clearInterval(intervalTotalTicketsHandle);
    }
}

async function initTotalTicketsInterval() {
    if (intervalTotalTicketsHandle) {
        clearInterval(intervalTotalTicketsHandle);
    }

    intervalTotalTicketsHandle = window.setInterval(() => intervalTotalTicketsHandler(), 60 * 1000);
}

const raffleRemainingSeconds = ref(0);
let intervalDrawRemainingHandle = 0;
async function intervalDrawRemainingHandler() {
    if (raffleRemainingSeconds.value > 0) {
        raffleRemainingSeconds.value--;
    } else {
        if (defaultDrawData.value) {
            defaultDrawData.value.drawRemainingSeconds = 0;
        }

        if (intervalDrawRemainingHandle) {
            clearInterval(intervalDrawRemainingHandle);
        }

        await loadDefaultDrawData();
    }
}

async function initDrawRemainingInterval() {
    if (intervalDrawRemainingHandle) {
        clearInterval(intervalDrawRemainingHandle);
    }

    intervalDrawRemainingHandle = window.setInterval(() => intervalDrawRemainingHandler(), 1000);
}

function initCountdowns(raffleRemaining: number) {
    raffleRemainingSeconds.value = raffleRemaining;

    initTotalTicketsInterval();
    initDrawRemainingInterval();
}

watch(
    () => defaultDrawData.value?.drawRemainingSeconds,
    (newRaffleRemainingSeconds) => {
        if (newRaffleRemainingSeconds) {
            initCountdowns(newRaffleRemainingSeconds);
        } else {
            clearInterval(intervalDrawRemainingHandle);
        }
    },
    { immediate: true }
);

watch(isLoggedIn, (newVal) => {
    if (!newVal) {
        clearInterval(intervalTotalTicketsHandle);
        clearInterval(intervalDrawRemainingHandle);
    }
});

export default function useBonusomatDrawCountdown() {
    return {
        raffleRemainingSeconds,
    };
}
